import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { supabase } from "@/lib/supabase";

const DeteleAccount = ({
  confirmDialog,
  setConfirmDialog,
  fetchAccounts,
}: any) => {
  return (
    <AlertDialog
      open={confirmDialog.open}
      onOpenChange={(open) =>
        !open && setConfirmDialog({ open: false, accountId: null })
      }
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Eliminar cuenta?</AlertDialogTitle>
          <AlertDialogDescription>
            Esta acción eliminará la cuenta y sus movimientos. No se puede
            deshacer.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={async () => {
              await supabase
                .from("accounts")
                .delete()
                .eq("id", confirmDialog.accountId);
              setConfirmDialog({ open: false, accountId: null });
              fetchAccounts();
            }}
          >
            Eliminar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeteleAccount;
